import type { ReactNode } from 'react';
import { NavLink, Outlet } from 'react-router';
import { SETTINGS_NAV } from '../../../app/layout/nav';
import { cn } from '../../../lib/cn';

/**
 * Ustawienia (Figma 12 Ustawienia): kolumna podstron 200 px po lewej, treść do 796 px.
 * Mobile: podstrony jako przewijany pasek nad treścią (pozycje 44 px — lifting 17.10.2026).
 */
export function SettingsLayout() {
  return (
    <div className="px-4 pt-6 pb-16 md:flex md:gap-10 md:pt-12 md:pr-8 md:pl-[34px]">
      <div className="md:w-[190px] md:shrink-0">
        <h1 className="text-h2 text-fg md:text-h4">Ustawienia</h1>
        <nav
          aria-label="Ustawienia"
          className="-mx-4 mt-4 flex gap-1 overflow-x-auto px-4 [scrollbar-width:none] md:mx-0 md:mt-5 md:-ml-2.5 md:w-[200px] md:flex-col md:gap-0 md:overflow-visible md:px-0"
        >
          {SETTINGS_NAV.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  cn(
                    'flex h-11 shrink-0 items-center gap-2.5 rounded-lg px-3 text-body-s whitespace-nowrap transition-colors md:h-9 md:px-2.5',
                    'focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-accent',
                    isActive
                      ? 'bg-elevated font-medium text-fg'
                      : 'text-fg-secondary hover:bg-elevated/60 hover:text-fg',
                  )
                }
              >
                <Icon size={17} strokeWidth={1.75} aria-hidden className="shrink-0 text-fg-muted" />
                {item.label}
              </NavLink>
            );
          })}
        </nav>
      </div>
      <div className="mt-8 min-w-0 flex-1 md:mt-0 md:max-w-[796px]">
        <Outlet />
      </div>
    </div>
  );
}

/** Nagłówek podstrony Ustawień (tytuł H3 + opis, akcje po prawej). */
export function SettingsHeader({
  title,
  description,
  actions,
}: {
  title: string;
  description?: string;
  actions?: ReactNode;
}) {
  return (
    <header className="flex flex-col gap-4 md:flex-row md:items-center">
      <div className="min-w-0 flex-1">
        <h2 className="text-h3 text-fg">{title}</h2>
        {description && <p className="mt-1 text-body-s text-fg-secondary">{description}</p>}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </header>
  );
}
